import { globalStore } from 'stores/globalStore'

export const getUserUnits = () => globalStore.getState().startupData?.guessedLocation.units ?? 'IMPERIAL'
